class SearchTabs extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.setupListeners()
  }

  setupListeners () {
    this.handleTabClick = this.handleTabClick.bind(this)

    if (this.els.heading) {
      this.els.heading.elements.forEach((headingEl) => {
        this.listeners.add(headingEl, 'click', this.handleTabClick)
      })
    }
  }

  handleTabClick (event) {
    event.stopPropagation()

    const handle = event.target.getAttribute('data-handle')
    const tabElement = window.BAO.Utils.getElement(
      `${this.els.tab.selector}[data-handle='${handle}']`,
    )

    if (!tabElement.classList.contains('klv-QuickSearch_TabItem-active')) {
      this.els.heading.elements.forEach((headingEl) => {
        headingEl.classList.remove('klv-QuickSearch_Tab-active')
      })

      event.target.classList.add('klv-QuickSearch_Tab-active')

      this.els.tab.elements.forEach((tabEl) => {
        tabEl.classList.remove('klv-QuickSearch_TabItem-active')
      })

      tabElement.classList.add('klv-QuickSearch_TabItem-active')
    }
  }
}

if (!customElements.get('search-tabs')) {
  customElements.define('search-tabs', SearchTabs)
}
